export class Constants {

  public static BEARER_PREFIX = 'Bearer ';

  public static PERCENT = '%';

  public static APOSTROPHE = '\'';

  public static DOT = '.';

  public static COLON = ':';

  public static SEMICOLON = ';';

  public static PLUS = '+';

  public static HYPHEN = '-';

  public static DASH = '—';

  public static EQUALS = '=';

  public static CHF = 'CHF';

  public static UTC = 'UTC';

  public static ZERO = '0';

  public static SWISS_PHONE_MASK = '+00 00 000 00 0099';

  public static FORMAT_DATE_PPL = 'dd.MM.yyyy';

  public static readonly PREMIUM_ROOT_TRANSLATION_KEY = 'premium';

}
